import type { RowSelectionState } from '@tanstack/react-table'

type VirtualRange = { start: number; end: number }

export function getSelectedRows<T extends { id: string }>(
  rows: T[],
  rowSelection: RowSelectionState,
): T[] {
  return rows.filter((row) => rowSelection[row.id])
}

// Heights of the spacer rows above and below the rendered window, so a
// virtualized <tbody> keeps the full scroll height while the table keeps
// native table layout.
export function getVirtualPadding(
  items: VirtualRange[],
  totalSize: number,
): { top: number; bottom: number } {
  if (items.length === 0) return { top: 0, bottom: 0 }
  return {
    top: items[0].start,
    bottom: totalSize - items[items.length - 1].end,
  }
}
